import { createFileRoute, Link } from "@tanstack/react-router";
import type { JSX } from "react";

import IllustrationConfetti from "@repo/icons/colored/IllustrationConfetti";

import oldDoctorWithPatient from "@/assets/old-doctor-with-patient.webp";
import { Button } from "@/components/ui/button/button";
import { ImageDrawerLayout } from "@/components/ui/layout/image-drawer/image-drawer-layout";

const AddPaymentCardPage = (): JSX.Element => {
  return (
    <ImageDrawerLayout>
      <ImageDrawerLayout.Image>
        <img
          src={oldDoctorWithPatient}
          alt="Profissional de saúde recebendo paciente na Livance"
          className="w-full h-full object-cover object-top"
        />
      </ImageDrawerLayout.Image>

      <ImageDrawerLayout.Drawer>
        <div className="flex flex-col gap-2">
          <IllustrationConfetti size={80} aria-hidden="true" />
          <h1 className="text-2xl font-medium text-neutral-700 leading-[1.32]">
            Vamos cadastrar o seu cartão de crédito?
          </h1>
          <div className="text-base text-neutral-600 font-normal leading-[1.32]">
            <p>
              É nele que vamos cobrar a sua mensalidade, uso de sala e outros serviços a
              cada 30 dias. Mas não se preocupe: a primeira cobrança é feita apenas no mês
              seguinte da ativação do seu consultório.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Link to="/add-payment-card/create">
            <Button fullWidth>Continuar</Button>
          </Link>
        </div>
      </ImageDrawerLayout.Drawer>
    </ImageDrawerLayout>
  );
};

export const Route = createFileRoute("/add-payment-card/")({
  component: AddPaymentCardPage,
});
